import { trigger, transition, style, animate } from "@angular/animations";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgSelectConfig } from "@ng-select/ng-select";
import { FormAutomation } from "src/app/form/form-automation";
import { Library } from "src/app/models/library";
import { ActionService } from "src/app/services/action.service";
import { ApplicationPool } from "src/app/services/application.pool";
import { Globals } from "src/app/services/globals";
import { NavigationService } from "src/app/services/navigation.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-library-selector",
  templateUrl: "./library-selector.component.html",
  styleUrls: [
    "./library-selector.component.scss",
    "../template/template.component.scss",
  ],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ height: "45px", opacity: 1 }),
        animate("1s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("inAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class LibrarySelectorComponent implements OnInit {
  public loading: boolean = false;
  public FormAutomation = FormAutomation;

  public get IsTesting(): boolean {
    return environment.testing;
  }

  private lastRunSelectedId: number = null;

  public get libraries(): Library[] {
    if (
      this.dataPool.GeneralLibraries &&
      !this.lastRunSelectedId &&
      !this.isSameOrigin()
    ) {
      this.lastRunSelectedId = Globals.LastSelectedLibraryId;
      if (this.lastRunSelectedId) {
        const libs = this.dataPool.GeneralLibraries.filter(
          (l) => l.id == this.lastRunSelectedId
        );
        if (libs.length > 0 && !this.library) {
          this.library = libs[0];
          this.execLogin();
        }
      }
    }
    return this.dataPool.GeneralLibraries;
  }

  isSameOrigin(): boolean {
    return this.navigationService.length > 0;
  }

  private interval: any;
  constructor(
    private dataService: ActionService,
    private dataPool: ApplicationPool,
    private router: Router,
    config: NgSelectConfig,
    private navigationService: NavigationService
  ) {
    config.bindLabel = "label";
    config.notFoundText = "Kein Ergebnis";
    config.openOnEnter = true;

    this.interval = setInterval(() => {
      if (this.dataPool.isLoading && this.libraries) {
        this.dataPool.getLoadingMap().clear();
      }
    }, 500);
  }
  ngOnDestroy() {
    clearInterval(this.interval);
  }

  ngOnInit() {}

  library: Library;

  public async execLogin() {
    if (this.library) Globals.LastSelectedLibraryId = this.library.id;
    this.loading = true;
    await this.dataService.selectLibrary(this.library).catch(() => {
      this.router.navigate(["/"]);
    });
    this.loading = false;
    this.router.navigate(["/public"]);
  }

  compare(lib1: Library, lib2: Library) {
    if (lib1 && lib2) return lib1.id == lib2.id;
    return lib1 == lib2;
  }

  get isConnected() {
    return this.dataPool.isConnected;
  }
}
